import { Injectable } from '@angular/core';

import {   EntityStatus, HttpGeneralService, OutpatientParms} from '../../shared';
import { RegPatService } from '../reg-pat-service/reg-pat-service'
  
import { CONFIG } from '../../shared/config';
import { CallData } from '../../call-center/call-center-reservation/call-center-reservation.service';
let reservationVisitUrl = CONFIG.baseUrls.reservationVisit;

@Injectable()
export class CancelServiceService {


    constructor(
        private _httpGeneralService: HttpGeneralService) { }

    getSpecificService(id: number, newServiceStatus: number) {

    }

    changeServiceStatus(selectedService: RegPatService) {
        return this._httpGeneralService.add(selectedService, `${reservationVisitUrl}/ChangeStatus`);
    }
    CCcallDataArriveResultCancel(selectedService: CallData) {
        return this._httpGeneralService.add(selectedService, `${reservationVisitUrl}/CCcallDataArriveResultCancel`);
    }

    SavePatServiceCancellation(patServiceCancel: PatServiceCancel) {
        return this._httpGeneralService.add(patServiceCancel, `${reservationVisitUrl}/RegPatServiceCancel`);
    }

    SaveAccomodationCancelation(regPatServiceCancel: RegPatServiceCancel) {
        return this._httpGeneralService.add(regPatServiceCancel, `${reservationVisitUrl}/PatAccomodation`);
    }
    
    SaveItemsCancelation(regPatServiceCancel: RegPatServiceCancel) {
        return this._httpGeneralService.add(regPatServiceCancel, `${reservationVisitUrl}/PatItems`);
    }
}


export interface RegPatServiceCancel {
    serial: number;
    deletedSerial?: number;
    cancelReason?: string;
    cancelReasonHeader?: number;
    recieptCancelFlag?: number;
    type?: number;
    visitSerial?:number;
    transDate?:Date;
}

export interface PatServiceCancel {
    RegPatService: RegPatService,
    RegPatServiceCancel: RegPatServiceCancel
}